import angular from 'angular';

angular.module('webTools').directive('wtSectionPanel', function() {
    return {
        restrict: 'A',
        replace: false,
        transclude: false,
        link: function(scope, element, attributes) {

            element.addClass('section-panel');
            element.children('li').children('span:first-child').addClass('expanded').siblings('div').show();
            element.children('li').children('span:first-child').bind('click', function() {
                if (angular.element(this).hasClass('expanded')) {
                    angular.element(this).removeClass('expanded').siblings('div').hide();
                } else {
                    angular.element(this).addClass('expanded').siblings('div').show();
                }
            })
        }
    };
});